"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOauthApi = void 0;

var _react = require("@reduxjs/toolkit/query/react");

var _objects = require("../utilities/objects");

var createOauthApi = function createOauthApi(baseUrl) {
  return (0, _react.createApi)({
    reducerPath: 'oauthApi',
    baseQuery: (0, _react.fetchBaseQuery)({
      baseUrl: "".concat(baseUrl, "/oauth2/token")
    }),
    endpoints: function endpoints(builder) {
      return {
        login: builder.mutation({
          query: function query(params) {
            return {
              body: (0, _objects.toFormUrlEncoded)(params),
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
              },
              method: 'POST',
              url: '/auth'
            };
          },
          transformResponse: function transformResponse(response) {
            return (0, _objects.toCamelCase)(response);
          }
        }),
        logout: builder.mutation({
          query: function query(params) {
            return {
              body: params,
              credentials: 'include',
              method: 'POST',
              url: '/revoke'
            };
          },
          transformResponse: function transformResponse(response) {
            return (0, _objects.toCamelCase)(response);
          }
        })
      };
    }
  });
};

exports.createOauthApi = createOauthApi;